import { getValidCountryData } from "@multimediallc/web-utils/countryFlags"
import { ReactWrapper } from "../ReactWrapper"
// TODO(CBD-2187) remove re-exports
export { getValidCountryData, isBlockedCountry } from "@multimediallc/web-utils/countryFlags"

export function addCountryFlags(): void {
    const flagSpans: NodeListOf<HTMLSpanElement> = document.querySelectorAll(".room_list_room span[data-country]")
    flagSpans.forEach(flagSpan => {
        const { flagCode, flagName } = getValidCountryData(flagSpan.dataset.country)
        if (flagCode && flagName) {
            flagSpan.appendChild(new ReactWrapper({
                component: "FlagIcon",
                componentProps: {
                    countryCode: flagCode,
                    countryName: flagName,
                },

            }).render())
        } else {
            flagSpan.remove()
        }
    })
}

